import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TestSignalWithDataMutationVariables = Types.Exact<{
  signalId: Types.Scalars['UUID']['input'];
  input: Types.TestSignalInput;
}>;

export type TestSignalWithDataMutation = {
  __typename?: 'Mutation';
  testSignalWithData: {
    __typename?: 'TestSignalResult';
    overallMatch: boolean;
    fetchedDataSummary?: string | null;
    error?: string | null;
    fingerprintResults: Array<{
      __typename?: 'FingerprintMatchResult';
      field: string;
      expected: string;
      actual: string;
      matched: boolean;
    }>;
  };
};

export const TestSignalWithDataDocument = gql`
  mutation TestSignalWithData($signalId: UUID!, $input: TestSignalInput!) {
    testSignalWithData(signalId: $signalId, input: $input) {
      overallMatch
      fingerprintResults {
        field
        expected
        actual
        matched
      }
      fetchedDataSummary
      error
    }
  }
`;
export type TestSignalWithDataMutationFn = Apollo.MutationFunction<
  TestSignalWithDataMutation,
  TestSignalWithDataMutationVariables
>;

/**
 * __useTestSignalWithDataMutation__
 *
 * To run a mutation, you first call `useTestSignalWithDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestSignalWithDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testSignalWithDataMutation, { data, loading, error }] = useTestSignalWithDataMutation({
 *   variables: {
 *      signalId: // value for 'signalId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestSignalWithDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TestSignalWithDataMutation,
    TestSignalWithDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TestSignalWithDataMutation,
    TestSignalWithDataMutationVariables
  >(TestSignalWithDataDocument, options);
}
export type TestSignalWithDataMutationHookResult = ReturnType<
  typeof useTestSignalWithDataMutation
>;
export type TestSignalWithDataMutationResult =
  Apollo.MutationResult<TestSignalWithDataMutation>;
export type TestSignalWithDataMutationOptions = Apollo.BaseMutationOptions<
  TestSignalWithDataMutation,
  TestSignalWithDataMutationVariables
>;
